import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose, mapProps, setDisplayName, setPropTypes } from 'recompose';

import { selectFakeWidth } from '../../store/responsive/selectors';

import { MediaQuery } from './media-query';

export const BREAKPOINTS = [0, 700, 980, 1024];

export const responsiveConnector = connect((state) => ({
  fakeWidth: selectFakeWidth(state),
}));
const slicePropType = setPropTypes({
  slice: PropTypes.number,
});

export const To = compose(
  setDisplayName('To'),
  slicePropType,
  mapProps(({ slice, ...props }) => ({
    maxWidth: BREAKPOINTS[slice],
    ...props,
  })),
  responsiveConnector
)(MediaQuery);

export const From = compose(
  setDisplayName('From'),
  slicePropType,
  mapProps(({ slice, ...props }) => ({
    minWidth: BREAKPOINTS[slice - 1] + 1,
    ...props,
  })),
  responsiveConnector
)(MediaQuery);

export const Between = compose(
  setDisplayName('Between'),
  setPropTypes({
    from: PropTypes.number,
    to: PropTypes.number,
  }),
  mapProps(({ from, to, ...props }) => ({
    minWidth: BREAKPOINTS[from - 1] + 1,
    maxWidth: BREAKPOINTS[to - 1],
    ...props,
  })),
  responsiveConnector
)(MediaQuery);

export const At = compose(
  setDisplayName('At'),
  slicePropType,
  mapProps(({ slice, ...props }) => ({
    minWidth: BREAKPOINTS[slice - 1] + 1,
    maxWidth: BREAKPOINTS[slice],
    ...props,
  })),
  responsiveConnector
)(MediaQuery);
